import React from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title
} from 'chart.js';
import { Pie } from 'react-chartjs-2';

// Register required Chart.js components
ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  Title
);

const statusColors = {
  'In Kitchen': 'rgba(255, 99, 132, 0.7)',
  'Prepared': 'rgba(54, 162, 235, 0.7)',
  'Dispatched': 'rgba(255, 206, 86, 0.7)',
  'Delivered': 'rgba(75, 192, 192, 0.7)',
  'Cancelled': 'rgba(153, 102, 255, 0.7)'
};

const PieChart = ({ statusData }) => {
  // Prepare chart data
  const data = {
    labels: Object.keys(statusData),
    datasets: [
      {
        data: Object.values(statusData),
        backgroundColor: Object.keys(statusData).map(status => statusColors[status] || '#cccccc'),
        borderColor: 'rgba(255, 255, 255, 1)',
        borderWidth: 1,
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: false,
        text: 'Order Status Distribution',
        font: {
          size: 16
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = Math.round((value / total) * 100);
            return `${label}: ${value} (${percentage}%)`;
          }
        }
      }
    },
  };

  return <Pie data={data} options={options} />;
};

export default PieChart;